import * as React from 'react'
import { IMemberSearchObject, IStateOrganizationTeamMember } from '../../types/index'
import Modal from '../ui/Modal'

export interface ITeamMemberSendInviteModalProps {
  teamMember: IMemberSearchObject
  onClose: () => void
  onSendInviteClick: (teamMember: IMemberSearchObject) => Promise<IStateOrganizationTeamMember>
}

interface ISendInviteModalState {
  isPending: boolean
  error: string
  email: string
}

class TeamMemberSendInviteModal extends React.Component<ITeamMemberSendInviteModalProps, ISendInviteModalState> {
  constructor(props: ITeamMemberSendInviteModalProps) {
    super(props)
    this.state = {
      isPending: false,
      error: '',
      email: props.teamMember ? props.teamMember.email : ''
    }
  }

  public render() {
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='bg-white col-3 p2'>
            <span className='font-small weight-300 font-grey2'>SEND INVITE</span>

            <div className='mt1'>
              <label className='font-small weight-300 font-grey3'>E-mail</label>
              <input type='text' name='email' value={this.state.email} onChange={this.handleEmailChanged} />
            </div>

            <div className='flex items-center justify-end mt3'>
              <button
                type='button'
                onClick={this.handleCancelClick}
                className='btn bg-white rounded font-light-grey mr2'
              >
                Cancel
              </button>

              <button
                type='button'
                disabled={this.state.isPending}
                onClick={this.handleSendClick}
                className='btn bg-green rounded font-white weight-300'
              >
                Send Invite
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private handleEmailChanged = (e: any) => {
    this.setState({ ...this.state, email: e.target.value })
  }

  private handleCancelClick = () => {
    this.props.onClose()
  }

  private handleSendClick = () => {
    this.setState({ ...this.state, isPending: true, error: '' })
    this.props
      .onSendInviteClick(this.props.teamMember)
      .then(teamMember => {
        this.props.onClose()
      })
      .catch(error => {
        this.setState({ ...this.state, isPending: false, error })
      })
  }
}

export default TeamMemberSendInviteModal



// WEBPACK FOOTER //
// ./src/components/team-members/TeamMemberSendInviteModal.tsx